export { default } from "./SkeletonCategoriesFilter-component";
